import { Injectable } from '@angular/core';
import { GraphService } from './graph.service';
import { WebViewInteropService } from './web-view-interop.service';
import { ICrmData, callEntry } from '../models/callContext.model';
import { Observable } from 'rxjs';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class CallDataManagerService {

  constructor(private graphService: GraphService, private interopService: WebViewInteropService, private logger: LoggerService){}

  async getCustomData(entry: callEntry){
    this.logger.log("CallDataManagerService: Waiting for crm response");
    entry.crmData.custom = (await entry.customPromise as ICrmData).custom!;
    entry.crmData.actions =  (await entry.customPromise as ICrmData).actions!;
    entry.customPromise = undefined; //we want to delete the promise here. so we can avoid duplicate awaits

    //search for the object "Name". replace displayname if object exists
    var customName = entry.crmData.custom.find(item => item.title === "Name");
    if(customName != undefined)
    {
      entry.displayName = customName.value;
    }

    this.logger.log("CallDataManagerService: Saving call entry");
    this.interopService.saveCallEntry(entry);
  }

  saveCallData(entry: callEntry)
  {
    if(entry.customPromise)
    {
      this.getCustomData(entry);
    }
    else
    {
      this.logger.log("CallDataManagerService: saveCallEntry");
      this.interopService.saveCallEntry(entry);
    }
  }

  graphResolveName(id: string): Observable<any> | undefined
  {
    this.logger.log("CallDataManagerService: Resolving name... ", id);
    return this.graphService.resolveName(id);
  }
}
